function EntriesIcon({ white = false }: { white?: boolean }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_2200_9694)">
				<mask
					id="mask0_2200_9694"
					style={{ maskType: "luminance" }}
					maskUnits="userSpaceOnUse"
					x="0"
					y="-1"
					width="25"
					height="25"
				>
					<path
						d="M0.00195312 -0.000120163H24.002V23.9999H0.00195312V-0.000120163Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask0_2200_9694)">
					<path
						d="M23.0625 16.6092H19.4219C17.8686 16.6092 16.6094 17.8684 16.6094 19.4217V23.0624M23.0625 16.6092C23.0625 17.7898 22.5935 18.922 21.7588 19.7567L19.7568 21.7586C18.9221 22.5934 17.79 23.0624 16.6094 23.0624M23.0625 16.6092V5.63191C23.0625 4.38686 22.5679 3.19277 21.6875 2.31236C20.8071 1.432 19.613 0.937378 18.368 0.937378H5.63203C4.38698 0.937378 3.19289 1.432 2.31248 2.31236C1.43213 3.19277 0.9375 4.38686 0.9375 5.63191V18.3678C0.9375 19.6129 1.43213 20.807 2.31248 21.6874C3.19289 22.5678 4.38698 23.0624 5.63203 23.0624H15.6875H16.6094M6.46875 17.5311H12M6.46875 6.46863H17.5312M6.46875 11.9999H17.5312"
						stroke={white ? "white" : "#4D5561"}
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_2200_9694">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default EntriesIcon;
